'use client'
import React from 'react'
import IndHeroSection from './components/IndHeroSection'
import IndSectionTwo from './components/IndSectionTwo'
import { useIndustriesNavbarScroll } from '@/Hooks'
import SocialSectionThree from './components/SocialSectionThree'
import SocialFromStrategy from './components/SocialFromStrategy'
import InnovativeFeatures from './components/InnovativeFeatures'
import SocialWhyChoose from './components/SocialWhyChoose'
import {
   ContactUsForm,
   FAQs,
   GameChangingIdea,
   WordsOfAppreciation,
} from '@/components'

const faqData = [
   {
      question: 'What are the key features of a social or dating app?',
      answer:
         'Social or dating apps offer functionality such as user profile management and real-time messaging and AI-powered dating recommendations in addition to location search options together with purchasing features and video chat options and security features for privacy protection.',
   },
   {
      question: 'How long does it take to develop a social or dating app?',
      answer:
         'The timeline is subject to the complexity, features, and integrations needed. A light version can happen within a few months, and a feature-filled platform with AI-powered matchmaking and video streaming could take more time.',
   },
   {
      question: 'Can you integrate AI-powered matchmaking in a dating app?',
      answer:
         'Our usage of AI algorithms studies user behavior along with preferences to create better matches through AI-powered matchmaking features which enhance user satisfaction.',
   },
   {
      question: 'How do you ensure security and data privacy in social apps?',
      answer:
         'We implement end-to-end encryption, GDPR/CCPA support, AI-based fraud protection, secure payment processing, and user authentication measures to protect data and user interactions.',
   },
   {
      question:
         'What monetization strategies can be integrated into a dating app?',
      answer:
         'Standard monetization methods are subscription plans, in-app purchases, freemium models, advertising, virtual gifts, and premium profile features to boost revenue generation.',
   },
   {
      question:
         'Can a social networking app support live streaming and video calls?',
      answer:
         'We implement real-time video streaming technology together with live events and HD video calling and low-latency solutions to develop an interactive and immersive user encounter.',
   },
   {
      question:
         'How do AI-powered content recommendations work in social apps?',
      answer:
         'AI algorithms read user behavior, preferences, and engagement history to recommend relevant profiles, posts, or content, enhancing user retention and interaction.',
   },
   {
      question:
         'What third-party integrations are possible in social and dating apps?',
      answer:
         'We support social logins, payment gateways, AI chatbots, CRM integration, geolocation services, analytics tools, and cloud databases with ease.',
   },
   {
      question: 'How scalable are your social and dating app solutions?',
      answer:
         'Seamless scalability is provided by our cloud-based infrastructure, handling millions of users with real-time synchronization, effective load balancing, and high-speed performance.',
   },
   {
      question:
         'What post-launch support do you provide for social networking apps?',
      answer:
         'Our team provides round-the-clock maintenance services in combination with emergency security updates as well as platform optimization to make your social networking app both competitive and secure.',
   },
];

function SocialAndDatingPage() {
   useIndustriesNavbarScroll()
   return (
      <>
         <IndHeroSection />
         <IndSectionTwo />
         <SocialSectionThree />
         <SocialFromStrategy />
         <InnovativeFeatures />
         <SocialWhyChoose />
         <GameChangingIdea />
         <section className="section appreciation-slider-section page_top_section section_secondary_bg">
            <WordsOfAppreciation />
         </section>
         <FAQs faqsConst={faqData} />

         <ContactUsForm />
      </>
   )
}

export default SocialAndDatingPage
